
import {gql, useQuery} from '@apollo/client';

export interface Result {
	auth: {
		id: string
		user?: {
			appts: Appointment[]
		}
	}
}

export type Appointment = {
	id: string
	details: {
		start: {
			timezone: string;
			unix: number;
		}
		location: {
			details: {
				name: string;
				address: {
					addr1: string;
					addr2: string;
				}
			}
			regions: {
				airtable: string;
				primary: string;
			}
		}
		icsCalendar: string
	}
	reservation: {
		reserved: {
			timezone: string;
			unix: number;
		}
	}
}

const getAppointments = gql`
query {
	auth {
		id
		user {
			id
			appts
				{
				id
				details {
					id
					start {
						timezone
						unix
					}
					location {
						id
						details {
							id
							name
							address {
								addr1
								addr2
							}
						}
						regions {
							airtable
							primary
						}
					}
					icsCalendar
				}
				reservation {
                    reserved {
						timezone
						unix
                    }
                }
			}
		}
	}
}`;

export const useAppointments = () => {
	return useQuery<Result>(getAppointments);
};

